import { render, staticRenderFns } from "./DownloadItem.vue?vue&type=template&id=087d9c77&scoped=true"
import script from "./DownloadItem.vue?vue&type=script&lang=js"
export * from "./DownloadItem.vue?vue&type=script&lang=js"
import style0 from "./DownloadItem.vue?vue&type=style&index=0&id=087d9c77&prod&lang=scss&scoped=true"
import style1 from "./DownloadItem.vue?vue&type=style&index=1&id=087d9c77&prod&lang=scss&scoped=true"
import style2 from "./DownloadItem.vue?vue&type=style&index=2&id=087d9c77&prod&lang=scss&scoped=true"
import style3 from "./DownloadItem.vue?vue&type=style&index=3&id=087d9c77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087d9c77",
  null
  
)

export default component.exports